{
  "version": 1,
  "asset_id": "9f7a971f-4420-4b6a-b1b8-1a916c7466e5",
  "project_id": "323b9e15-9042-4162-b531-66ca33513bd6",
  "url": "/__l5e/assets-v1/9f7a971f-4420-4b6a-b1b8-1a916c7466e5/cat_city_256.png",
  "r2_key": "a/v1/323b9e15-9042-4162-b531-66ca33513bd6/9f7a971f-4420-4b6a-b1b8-1a916c7466e5/cat_city_256.png",
  "original_filename": "cat_city_256.png",
  "size": 277786,
  "content_type": "image/webp",
  "created_at": "2026-10-28T09:29:59Z"
}
